import color from "../../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
    flexWrap: "wrap",
    gap: 2,
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    textTransform: "capitalize",
  },
  addButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "50px",
    textTransform: "none",
    px: 3,
    py: 1,
    fontWeight: 500,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#228A3A",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    },
  },
  filtersCard: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    p: 3,
    mb: 3,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  businessReportsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    flexWrap: "wrap",
  },
  filtersTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: color.text,
    m: 0,
  },
  filterLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: color.lightText,
  },
  filterSelect: {
    borderRadius: "8px",
    fontSize: "14px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    "& .MuiSelect-select": {
      py: "10px",
    },
  },
  businessFilterButton: {
    borderRadius: 50,
    color: color.secondary,
    border: "1px solid #00ABF4",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none",
    py: "4px",
    px: 2,
    minWidth: "104px",
    "&:hover": {
      border: "1px solid #00ABF4",
      backgroundColor: "#EAF8FE",
    },
  },
  filterChips: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    mt: 2,
  },
  filterChip: {
    height: "28px",
    borderRadius: "50px",
    backgroundColor: color.lightGreen,
    color: color.text,
    fontSize: "12px",
    fontWeight: 500,
    "& .MuiChip-deleteIcon": {
      color: color.primary,
      fontSize: "16px",
      "&:hover": {
        color: "#228A3A",
      },
    },
  },
  businessFilterPopover: {
    mt: 1,
    width: { xs: "calc(100vw - 32px)", sm: "470px" },
    maxWidth: "470px",
    borderRadius: "8px",
    boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
    overflow: "hidden",
  },
  businessFilterContent: {
    display: "flex",
    alignItems: "stretch",
    backgroundColor: "#fff",
    flexDirection: { xs: "column", sm: "row" },
  },
  businessFilterNav: {
    width: { xs: "100%", sm: "190px" },
    py: 1,
    borderRight: { xs: "none", sm: `1px solid ${color.lightGray}` },
    borderBottom: { xs: `1px solid ${color.lightGray}`, sm: "none" },
    backgroundColor: "#fff",
  },
  businessFilterMenuItem: {
    minHeight: "44px",
    display: "flex",
    justifyContent: "space-between",
    gap: 3,
    fontSize: "14px",
    color: color.text,
    px: 2,
    "&.Mui-selected": {
      backgroundColor: color.lightGreen,
      fontWeight: 600,
      "&:hover": {
        backgroundColor: color.lightGreen,
      },
    },
    "&:hover": {
      backgroundColor: color.lightGray,
    },
  },
  clearFiltersButton: {
    color: color.lightText,
    textTransform: "none",
    fontSize: "14px",
    px: 2,
  },
  businessFilterPanel: {
    flex: 1,
    minWidth: 0,
    p: 2,
    backgroundColor: "#fff",
  },
  submenuTitle: {
    fontWeight: 600,
    fontSize: "15px",
    color: color.text,
    mb: 1.5,
  },
  submenuActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 1,
    mt: 2,
  },
  applyButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "8px",
    textTransform: "none",
    px: 2.5,
    py: 0.75,
    fontWeight: 500,
    fontSize: "14px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#228A3A",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    },
    "&:disabled": {
      backgroundColor: color.lightGray,
      color: color.lightText,
    },
  },
  metricsGrid: {
    mb: 3,
  },
  metricCard: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    p: 3,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  metricValue: {
    fontWeight: 600,
    fontSize: "28px",
    color: color.text,
    mb: 1,
  },
  metricLabel: {
    fontSize: "14px",
    color: color.lightText,
    fontWeight: 400,
  },
  tableSection: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    p: 3,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2,
    gap: 2,
    flexWrap: "wrap",
  },
  tableHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    flexWrap: "wrap",
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: color.text,
  },
  searchBox: {
    display: "flex",
    alignItems: "center",
    backgroundColor: color.lightGray,
    borderRadius: "30px",
    minWidth: "220px",
    maxWidth: "260px",
    width: "100%",
  },
  searchIconButton: {
    p: 1,
  },
  searchInput: {
    flex: 1,
    fontSize: "12px",
    pr: 1.5,
  },
  exportButton: {
      borderRadius: 50,
      color: color.secondary,
      border: "1px solid #00ABF4",
      textTransform: "none",
      fontSize: "12px",
      boxShadow: "none",
      py: "4px",
  },
  filterButton: {
      borderRadius: 50,
      color: color.secondary,
      border: "1px solid #00ABF4",
      textTransform: "none",
      fontSize: "12px",
      boxShadow: "none",
      py: "4px",
  },
  tableContainer: {
    boxShadow: "none",
    borderRadius: "8px",
  },
  tableHeaderCell: {
    fontWeight: 600,
    fontSize: "14px",
    color: color.lightText,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: color.lightGray,
    },
  },
  blockedRow: {
    backgroundColor: "#F1F1F1",
    opacity: 0.75,
  },
  tableCell: {
    fontSize: "14px",
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  blockedTableCell: {
    color: color.lightText,
  },
  statusChip: {
    fontSize: "12px",
    fontWeight: 500,
    height: "24px",
  },
  viewButton: {
    borderRadius: "8px",
    color: color.text,
    cursor: "pointer",
    userSelect: "none",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      backgroundColor: color.lightGray,
    },
  },
  viewIcon: {
    fontSize: "20px",
    color: "#878787",
    pointerEvents: "none",
  },
  editButton: {
    width: "30px",
    height: "30px",
    padding: 0,
  },
  editIcon: {
    fontSize: "18px",
  },
  emptyCell: {
    py: 4,
    color: color.lightText,
  },
};

export default style;
